import React, { useEffect, useState } from 'react'
import EditComponent from '../../Component/CompanyProfile/Edit'
import Loader from '../../Component/Common/Loader';
import { recruiterProfileDetails, updateCompanyProfile } from '../../action/profile';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../constant';
const EditProfile = () => {
    const history = useHistory();
    const [data, setData] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        recruiterProfileDetails().then((res) => {
            if (res.status) {
                setData(res.result)
            }
        }).finally(() => {
            setShowLoader(false)
        });
    }, [])

    const onSubmit = (model) => {
        setShowLoader(true);
        updateCompanyProfile(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                history.push(constant.component.viewProfile.url);
            } else {
                toast.error(res.error)
            }
        }).finally(() => {
            setShowLoader(false);
        });

    };
    return (
        <React.Fragment>
            {showLoader && <Loader />}
            {data && <EditComponent
                data={data}
                setShowLoader={setShowLoader}
                onSubmit={onSubmit}
            />}
        </React.Fragment>
    )
}

export default EditProfile